Object.defineProperty(exports, '__esModule', { value: true });

var react = require('react');
var fnUtils = require('../fnUtils.js');

var useIsMounted = function () {
    var isMountedRef = react.useRef(true);
    var runIfMounted = react.useRef(null);
    // safe to use in useEffect deps - once initiated it never changes
    if (fnUtils.fnUtils.isNil(runIfMounted.current)) {
        runIfMounted.current = function (callback) {
            if (!isMountedRef.current)
                return;
            callback();
        };
    }
    react.useEffect(function () { return function () {
        isMountedRef.current = false;
    }; }, []);
    return [isMountedRef, runIfMounted.current];
};

exports.useIsMounted = useIsMounted;
